import Vue from 'vue'
import App from '../components/terminals/App.vue'

document.addEventListener('DOMContentLoaded', () => {
    const app = new Vue({
        render: h => h(App, {
            props: {
                terminals: terminals,
                locale: locale
            }
        })
    }).$mount('#terminals-app')
})